import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import Breadcrumbs from '../../molecules/Breadcrumbs';
import GatsbyImage from '../Image/GatsbyImage';
import InfoBar from '../InfoBar/InfoBar';

import {
  Section,
  OuterWrapper,
  InnerWrapper,
  Details,
  Text,
  Content,
} from './styles/HeroBlogDetail.styled';
import ParallaxGrid from '../../molecules/ParallaxGrid';

const HeroBlogDetail = ({
  component: { internalName, metaTags, author, publishDate, readingTime, slug },
}) => {
  const { t } = useTranslation();

  return (
    <Section>
      <ParallaxGrid theme="light" />
      <OuterWrapper>
        <Breadcrumbs
          theme="dark"
          breadcrumbs={[
            {
              pathname: '/',
              title: '',
            },
            {
              pathname: '/resources/blog',
              title: 'Blog',
            },
            {
              pathname: `/blog/${slug || ''}`,
              title: internalName || '',
            },
          ]}
        />
        <InnerWrapper>
          <Details>
            <Text>
              <p className="eyebrow">{t('Blog Post')}</p>
              <h1 className="heading">{metaTags.title || internalName}</h1>
              {metaTags?.description && (
                <p className="subhead">{metaTags?.description}</p>
              )}
            </Text>
            <InfoBar
              readTime={readingTime}
              author={`${author?.firstName} ${author?.lastName}`}
              publishDate={publishDate}
            />
          </Details>
          <Content>
            <GatsbyImage
              src={metaTags?.image?.gatsbyImageData || metaTags?.image?.url}
              alt={metaTags?.image?.alt}
              height="592px"
              width="333px"
            />
          </Content>
        </InnerWrapper>
      </OuterWrapper>
    </Section>
  );
};

export default HeroBlogDetail;
